import {FC} from 'react'
import {getTemplateBedService, uploadTemplateService} from '../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
import {FormMasiveBulk} from '../../../../../../components/UI/Form/MasiveBulk'

const FormMasiveUploadBed: FC = () => {
  const handleUpload = async (formData: FormData, bulkLoadId: string): Promise<any> => {
    try {
      const response = await uploadTemplateService(formData, bulkLoadId) // Use the service to upload the file
      return response
    } catch (error) {
      console.error('Error uploading file:', error)
      // ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }
  return (
    <FormMasiveBulk
      serviceTemplate={getTemplateBedService}
      handleSendService={handleUpload}
      showModalList
      title='Camas'
    />
  )
}

export {FormMasiveUploadBed}
